import Popover from 'devextreme-react/popover';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useResize } from '../../../../hooks/useResize';
import Button from 'devextreme-react/button';
import icons from '../../icons/icons';
import FleetAccordion from '../fleet-accordion/FleetAccordion';
import VesselAccordion from '../vessel-accordion/VesselAccordion';
import { Fleet } from '../../../../types/fleet';
import ScrollView from 'devextreme-react/scroll-view';

export default function VesselFilterControl({
  onClose,
  target,
  visible,
  fleetList,
  onFleetSelectionChange,
  searchedVessels,
  onVesselSelectionChange,
  selectedFleetIds,
}: Readonly<{
  onClose: (value: boolean) => void;
  target: string;
  visible: boolean;
  fleetList: Fleet[];
  onFleetSelectionChange?: (selectedFleetIds: number[]) => void;
  searchedVessels: any[];
  onVesselSelectionChange?: (selectedVesselImos: string[]) => void;
  selectedFleetIds: number[];
}>) {
  const { isMobileResolution } = useResize();
  const { t } = useTranslation();
  const [position, setPosition] = useState<any>('left');

  useEffect(() => {
    if (isMobileResolution) {
      setPosition('left');
    }
  }, [isMobileResolution]);

  const popupAttributes = useMemo(() => {
    return {
      id: 'elementId',
      class: 'm-l-vessel-filter-popover',
      'data-testid': 'vesselFilterPopover',
    };
  }, []);

  return (
    <Popover
      id="vesselFilterPopover"
      width={300}
      target={target}
      position={position}
      wrapperAttr={popupAttributes}
      onHiding={() => onClose(false)}
      visible={visible}
      hideOnOutsideClick={true}
      hideOnParentScroll={false}
    >
      <div className="m-l-grid-clone-popup-wrap">
        <div className="m-l-grid-clone-popup-header m-l-grid-copy--popup-header">
          <h2>{t('labels.vesselFilter')}</h2>
          <div className="m-l-header-close__icon-block">
            <Button
              className="app-c-btn app-c-icon-only-btn"
              onClick={() => onClose(false)}
              elementAttr={{ 'data-testid': 'close' }}
            >
              <icons.IconCross />
            </Button>
          </div>
        </div>
        <ScrollView width="100%" height="100%">
          <div className="m-l-accordion-panel-body-block">
            <div className="m-l-accordion__main-section u-p0">
              <FleetAccordion
                fleetList={fleetList}
                onFleetSelectionChange={onFleetSelectionChange}
                selectedFleetIds={selectedFleetIds}
              />
              <VesselAccordion
                searchedVessels={searchedVessels}
                onVesselSelectionChange={onVesselSelectionChange}
              />
            </div>
          </div>
        </ScrollView>
      </div>
    </Popover>
  );
}
